export const KEEP_SIGNED_IN_ACCEPT_LABEL = 'Enable';
export const KEEP_SIGNED_IN_DECLINE_LABEL = 'Not now';

export const EMAIL_CODE_LINK_LABEL = 'First time signing in? Email me a code';

// Human-facing sign-in failure copy. The Accounts API returns terse, internal strings
// ("Incorrect sign in data", "This user has not permission for sign-in") that leak
// implementation wording and never tell the user what to do; getLoginErrorMessage maps the
// failure to one of these by HTTP status. Deliberately generic: no internal role/claim names.
export const LOGIN_ERROR_MESSAGES = {
  invalidCredentials: 'The email or password you entered is incorrect. Please try again.',
  noAccess:
    "This account doesn't have access to this portal. Contact your administrator to request access.",
  tooManyAttempts: 'Too many sign-in attempts. Please wait a few minutes and try again.',
  serverError: 'Something went wrong on our end. Please try again in a moment.',
  network: "We couldn't reach the server. Check your connection and try again.",
  generic:
    "We couldn't sign you in. Please try again, or contact your administrator if this keeps happening.",
};

// Drive native password autofill (iOS/Android WebView + desktop browsers): the
// username/current-password autocomplete tokens let the OS offer the saved
// credential keyed to the app's associated web domain. autoCapitalize/autoCorrect
// off so the email field is not mangled on mobile keyboards.
export const USERNAME_INPUT_PROPS = {
  autoComplete: 'username',
  autoCapitalize: 'none',
  autoCorrect: 'off',
};

export const PASSWORD_INPUT_PROPS = {
  autoComplete: 'current-password',
};

export const getKeepSignedInPrompt = displayName => ({
  message: `Stay signed in with ${displayName}?`,
  description: `Use ${displayName} to skip the password next time. You can turn it off anytime.`,
});
